import { types } from '../constants';

export const fetchAllHazardsForBranchDispatch = (branchId) => ({
  type: types.FETCH_ALL_HAZARDS_FOR_BRANCH,
  branchId
});

export const fetchAllHazardsForCompanyDispatch = (companyId) => ({
  type: types.FETCH_ALL_HAZARDS_FOR_COMPANY,
  companyId
});

export const searchTermChangeForAllHazards = (searchTerm) => ({
  type: types.CHANGE_SEARCH_TERM_ALL_HAZARDS,
  searchTerm
});

export const openCreateHazardDialogDispatch = (open) => ({
  type: types.OPEN_CREATE_HAZARD_DIALOG,
  open
});

export const handleHazardInputChangeDispatch = (value, inputFieldName) => ({
  type: types.INPUT_CHANGE_CREATE_HAZARD_FORM,
  value,
  inputFieldName
});

export const submitHazardDispatch = (hazard, mode) => ({
  type: types.SUBMIT_HAZARD,
  hazard,
  mode
});

export const openEditHazardPanelDispatch = (open) => ({
  type: types.OPEN_EDIT_HAZARD_PANEL,
  open
});

export const openEditHazardDialogDispatch = (open) => ({
  type: types.OPEN_EDIT_HAZARD_DIALOG,
  open
});

export const hazardEditClickDispatch = (hazard) => ({
  type: types.EDIT_HAZARD,
  hazard
});

export const openDeleteHazardDialogDispatch = (open, hazard) => ({
  type: types.OPEN_DELETE_HAZARD_DIALOG,
  open,
  hazard
});

export const submitDeleteHazardRequestDispatch = (hazard) => ({
  type: types.DELETE_HAZARD,
  hazard
});

export const fetchControlsForTheHazardDispatch = (hazardId) => ({
  type: types.FETCH_CONTROLS_FOR_THE_HAZARD,
  hazardId
});

export const handleDeleteHazardControlClickDispatch = (payload) => ({
  type: types.DELETE_HAZARD_CONTROL,
  payload
});

export const submitControlDispatch = (payload, mode, branchId) => ({
  type: types.SUBMIT_HAZARD_CONTROL,
  payload,
  mode,
  branchId
});

export const enableEditHazardControlDispatch = (
  enableEditControlMode,
  controlId
) => ({
  type: types.ENABLE_EDIT_HAZARD_CONTROL,
  enableEditControlMode,
  controlId
});

export const handleEditHazardControlInputChangeDispatch = (
  value,
  inputFieldName
) => ({
  type: types.INPUT_CHANGE_EDIT_HAZARD_CONTROL,
  value,
  inputFieldName
});

export const openAddHazardControlDialogDispatch = (open) => ({
  type: types.OPEN_ADD_HAZARD_CONTROL_DIALOG,
  open
});

export const openDeleteHazardControlDialogDispatch = (open, controlId) => ({
  type: types.OPEN_DELETE_HAZARD_CONTROL_DIALOG,
  open,
  controlId
});

//HAZARD REVIEW
export const openHazardReviewPanelDispatch = (open) => ({
  type: types.OPEN_HAZARD_REVIEW_PANEL,
  open
});

export const handleEditHazardReviewInputChangeDispatch = (
  value,
  inputFieldName
) => ({
  type: types.INPUT_CHANGE_EDIT_HAZARD_REVIEW,
  value,
  inputFieldName
});

export const handleAddHazardReviewInputChangeDispatch = (
  value,
  inputFieldName
) => ({
  type: types.INPUT_CHANGE_ADD_HAZARD_REVIEW,
  value,
  inputFieldName
});

export const submitHazardReviewDispatch = (payload, mode, branchId) => ({
  type: types.SUBMIT_HAZARD_REVIEW,
  payload,
  mode,
  branchId
});

export const fetchReviewsForTheHazardDispatch = (hazardId) => ({
  type: types.FETCH_REVIEWS_FOR_THE_HAZARD,
  hazardId
});

export const handleDeleteHazardReviewClickDispatch = (payload) => ({
  type: types.DELETE_HAZARD_REVIEW,
  payload
});

export const openAddHazardReviewDialogDispatch = (open) => ({
  type: types.OPEN_CREATE_HAZARD_REVIEW_DIALOG,
  open
});

export const enableEditHazardReviewDispatch = (
  enableEditReviewMode,
  reviewId
) => ({
  type: types.ENABLE_EDIT_HAZARD_REVIEW,
  enableEditReviewMode,
  reviewId
});

export const openDeleteHazardReviewDialogDispatch = (open, reviewId) => ({
  type: types.OPEN_DELETE_HAZARD_REVIEW_DIALOG,
  open,
  reviewId
});

//Hazard Management Logs
export const openHazardManagementLogPanelDispatch = (open) => ({
  type: types.OPEN_HAZARD_MANAGEMENTLOG_PANEL,
  open
});

export const handleEditHazardManagementLogInputChangeDispatch = (
  value,
  inputFieldName
) => ({
  type: types.INPUT_CHANGE_EDIT_HAZARD_MANAGEMENT_LOG,
  value,
  inputFieldName
});

export const handleAddHazardManagementLogInputChangeDispatch = (
  value,
  inputFieldName
) => ({
  type: types.INPUT_CHANGE_ADD_HAZARD_MANAGEMENT_LOG,
  value,
  inputFieldName
});

export const submitHazardManagementLogDispatch = (payload, mode, branchId) => ({
  type: types.SUBMIT_HAZARD_MANAGEMENT_LOG,
  payload,
  mode,
  branchId
});

export const fetchManagementLogsForTheHazardDispatch = (hazardId) => ({
  type: types.FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD,
  hazardId
});

export const openAddHazardManagementLogDialogDispatch = (open) => ({
  type: types.OPEN_CREATE_HAZARD_MANAGEMENT_LOG_DIALOG,
  open
});

export const enableEditHazardManagementLogDispatch = (
  enableEditManagmentLogMode,
  managementLogId
) => ({
  type: types.ENABLE_EDIT_HAZARD_MANAGEMENT_LOG,
  enableEditManagmentLogMode,
  managementLogId
});

export const openDeleteHazardManagementLogDialogDispatch = (
  open,
  managementLogId
) => ({
  type: types.OPEN_DELETE_HAZARD_MANAGEMENT_LOG_DIALOG,
  open,
  managementLogId
});

export const changeHazardStatusTypeFilter = (statusId) => ({
  type: types.CHANGE_SELECTED_HAZARD_STATUS_FILTER,
  statusId
});

export const changeHazardDescriptionSortTypeFilter = (sortId) => ({
  type: types.CHANGE_SELECTED_HAZARD_DESCRIPTION_FILTER,
  sortId
});

export const removeAttachment = (attachment) => ({
  type: types.REMOVE_HAZARD_ATTACHMENT,
  attachment
});

export const fetchExistingAttachmentsForTheHazardDispatch = (
  domainTypeId,
  parentId,
  loggedInUserId
) => ({
  type: types.LOAD_ATTACHMENTS_FOR_HAZARD,
  domainTypeId,
  parentId,
  loggedInUserId
});

//Hazard Review Attachment
export const removeHazardReviewAttachment = (attachment) => ({
  type: types.REMOVE_HAZARD_REVIEW_ATTACHMENT,
  attachment
});

export const fetchExistingAttachmentsForHazardReviewDispatch = (
  domainTypeId,
  parentId,
  loggedInUserId
) => ({
  type: types.LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW,
  domainTypeId,
  parentId,
  loggedInUserId
});

export const removeHazardReviewAttachmentEdit = (attachment) => ({
  type: types.REMOVE_HAZARD_REVIEW_ATTACHMENT_EDIT,
  attachment
});

//Hazard Management Logs Attachment
export const removeHazardManagementLogsAttachment = (attachment) => ({
  type: types.REMOVE_HAZARD_MANAGEMENT_LOGS_ATTACHMENT,
  attachment
});

export const fetchExistingAttachmentsForHazardManagementLogsDispatch = (
  domainTypeId,
  parentId,
  loggedInUserId
) => ({
  type: types.LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS,
  domainTypeId,
  parentId,
  loggedInUserId
});

export const removeHazardManagementLogsAttachmentEdit = (attachment) => ({
  type: types.REMOVE_HAZARD_MANAGE_LOGS_ATTACHMENT_EDIT,
  attachment
});

//Hazard Control Attachment
export const removeHazardControlAttachment = (attachment) => ({
  type: types.REMOVE_HAZARD_CONTROL_ATTACHMENT,
  attachment
});

export const fetchExistingAttachmentsForHazardControlDispatch = (
  domainTypeId,
  parentId,
  userId
) => ({
  type: types.LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL,
  domainTypeId,
  parentId,
  userId
});

export const removeHazardControlAttachmentEdit = (attachment) => ({
  type: types.REMOVE_HAZARD_CONTROL_ATTACHMENT_EDIT,
  attachment
});
